import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from '@/components/LocalizedLink';

export default function NotFoundPage() {
  return (
    <section className="min-h-screen pt-32 pb-20 px-4 sm:px-6 lg:px-8 flex items-center" data-testid="not-found-page">
      <div className="max-w-xl mx-auto text-center">
        <p className="text-xs uppercase tracking-[0.3em] text-saffron font-sans font-semibold">Error 404</p>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-earth-dark mt-3 tracking-tight">Page not found</h1>
        <p className="mt-4 text-earth/60 font-sans leading-relaxed">The page you are looking for does not exist or has moved.</p>
        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          <Link to="/" className="inline-flex items-center gap-2 bg-saffron text-white font-sans font-semibold text-sm px-6 py-3 rounded-md hover:bg-saffron-dark transition-colors" data-testid="not-found-home">
            Go to Home <ArrowRight size={14} />
          </Link>
          <Link to="/products" className="inline-flex items-center gap-2 border border-earth/20 text-earth-dark font-sans font-semibold text-sm px-6 py-3 rounded-md hover:bg-earth/5 transition-colors" data-testid="not-found-products">
            View Products
          </Link>
        </div>
      </div>
    </section>
  );
}
